// import React from 'react'
// import { makeStyles ,alpha,InputBase, } from '@material-ui/core';
// import {Search}from '@material-ui/icons';
// const useStyle=makeStyles( (theme) =>({
//     search: { 
//         borderRadius: theme.shape.borderRadius,
//         backgroundColor: "#fff",
//         marginLeft: 10,
//         width: '38%',
//         display:'flex'
         
//       },
//       searchIcon: {
//         padding: 5,
//         height: '100%',
       
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         color:'blue'
//       },
//       inputRoot: {
//         fontSize:'unset',
//         width:'100%'
//       },
//       inputInput: {
//         paddingLeft:20
//       },
// }));
// const SearchBar = () => {
//     const classes=useStyle();
//     return (
//         <div className={classes.search}>
      
//         <InputBase
//           placeholder="Search for products,brands and more"
//           classes={{
//             root: classes.inputRoot,
//             input: classes.inputInput,
//           }}
//           inputProps={{ 'aria-label': 'search' }}
//         />
//          <div className={classes.searchIcon}>
//           <Search/>
//         </div>
//       </div>
//     )
// }

// export default SearchBar;

import { useState, useEffect } from 'react';

import SearchIcon from '@mui/icons-material/Search';
import { InputBase, List, ListItem, Box, styled } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux'; // hooks
import { getProducts as listProducts } from '../redux/actions/productActions';
import { Link } from 'react-router-dom';

const SearchContainer = styled(Box)`
  border-radius: 2px;
  margin-left: 10px;
  width: 38%;
  background-color: #fff;
  display: flex;
`;

const SearchIconWrapper = styled(Box)`
  margin-left: auto;
  padding: 5px;
  display: flex;
  color: blue;
`;

const ListWrapper = styled(List)`
  position: absolute;
  color: #000;
  background: #FFFFFF;
  margin-top: 36px;
`;

const InputSearchBase = styled(InputBase)`
  font-size: unset;
  width: 100%;
  padding-left: 20px;
`;

const Search = () => {
    const [ text, setText ] = useState();
    const [ open, setOpen ] = useState(true)

    const getText = (text) => {
        setText(text);
        setOpen(false)
    }

    const getProducts = useSelector(state => state.getProducts);
    const { products } = getProducts;

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(listProducts())
    }, [dispatch])

    return (
        <SearchContainer>
            <InputSearchBase
              placeholder="Search for products, brands and more"
              inputProps={{ 'aria-label': 'search' }}
              onChange={(e) => getText(e.target.value)}
            />
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            {
              text && 
              <ListWrapper hidden={open}>
                {
                  products.filter(product => product.title.longTitle.toLowerCase().includes(text.toLowerCase())).map(product => (
                    <ListItem>
                      <Link 
                        to={`/product/${product.id}`} 
                        style={{ textDecoration:'none', color:'inherit'}}
                        onClick={() => setOpen(true)}  
                      >
                        {product.title.longTitle}
                      </Link>
                    </ListItem>
                  ))
                }  
              </ListWrapper>
            }
        </SearchContainer>
    )
}

export default Search;